<template>
    <div class="remove-users">
        <b-modal
            id="remove-users-modal"
            title="Remove user"
            ok-title="Remove"
            :ok-disabled="users.length === 0"
            size="md"
            centered
            @ok="removeUsers">
            <p v-if="users.length > 0">Are you sure you want to remove the selected users?</p>
            <p v-else>No users selected. Please select at least one user.</p>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        users: {
            type: Array,
            required: true,
            default: null
        },
        project: {
            type: Object,
            required: true
        }
    },
    data() {
        return {}
    },
    computed: {},
    mounted() {
    },
    methods: {
        removeUsers() {
            let token = this.$store.state.token;
            let url = this.$store.getters.apiBase + '/projects/' + this.project.id + '/users/remove-multiple';
            let method = 'POST';

            axios({
                url: url,
                data: {
                    users: this.users
                },
                method: method,
                headers: {"Authorization": "Bearer " + token}
            })
                .then(response => {
                    let users = response.data.data;
                    this.$emit('ok', users);
                })
                .catch(error => {
                    console.log(error);
                });
        },
    },
    watch: {
        users(users) {
            console.log('users change', users);
        }
    },
}
</script>
